"use strict";

var _inherits = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _classCallCheck = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReverseCalldataIterator = exports.CalldataIterator = void 0;
/* tslint:disable max-classes-per-file */

var _ = require("lodash");

var queue_1 = require("../utils/queue");

var blob_1 = require("./blocks/blob");

var pointer_1 = require("./blocks/pointer");

var set_1 = require("./blocks/set");
/**
 * Iterator class for Calldata Blocks. Blocks follows the order
 * they should be put into calldata that is passed to he EVM.
 *
 * Example #1:
 * Let root = Set {
 *                  Blob{} A,
 *                  Pointer {
 *                      Blob{} a
 *                  } B,
 *                  Blob{} C
 *            }
 * It will iterate as follows: [A, B, C, B.a]
 *
 * Example #2:
 * Let root = Set {
 *                  Blob{} A,
 *                  Pointer {
 *                      Blob{} a
 *                      Pointer {
 *                          Blob{} b
 *                      }
 *                  } B,
 *                  Pointer {
 *                      Blob{} c
 *                  } C
 *            }
 * It will iterate as follows: [A, B, C, B.a, B.b, C.c]
 */


var BaseIterator = /*#__PURE__*/function () {
  function BaseIterator(root) {
    _classCallCheck(this, BaseIterator);

    this._root = root;
    this._queue = BaseIterator._createQueue(root);
  }

  _createClass(BaseIterator, [{
    key: Symbol.iterator,
    value: function value() {
      var _this = this;

      return {
        next: function next() {
          var nextBlock = _this.nextBlock();

          if (nextBlock !== undefined) {
            return {
              value: nextBlock,
              done: false
            };
          }

          return {
            done: true,
            value: new blob_1.BlobCalldataBlock('', '', '', Buffer.from(''))
          };
        }
      };
    }
  }], [{
    key: "_createQueue",
    value: function _createQueue(block) {
      var queue = new queue_1.Queue(); // Base case

      if (!(block instanceof set_1.SetCalldataBlock)) {
        queue.pushBack(block);
        return queue;
      } // This is a set; add members


      var set = block;

      _.eachRight(set.getMembers(), function (member) {
        queue.mergeFront(BaseIterator._createQueue(member));
      }); // Add children


      _.each(set.getMembers(), function (member) {
        // Traverse child if it is a unique pointer.
        // A pointer that is an alias for another pointer is ignored.
        if (member instanceof pointer_1.PointerCalldataBlock && member.getAlias() === undefined) {
          var dependency = member.getDependency();
          queue.mergeBack(BaseIterator._createQueue(dependency));
        }
      }); // Put set block at the front of the queue


      queue.pushFront(set);
      return queue;
    }
  }]);

  return BaseIterator;
}();

var CalldataIterator = /*#__PURE__*/function (_BaseIterator) {
  _inherits(CalldataIterator, _BaseIterator);

  var _super = _createSuper(CalldataIterator);

  function CalldataIterator(root) {
    _classCallCheck(this, CalldataIterator);

    return _super.call(this, root);
  }

  _createClass(CalldataIterator, [{
    key: "nextBlock",
    value: function nextBlock() {
      return this._queue.popFront();
    }
  }]);

  return CalldataIterator;
}(BaseIterator);

exports.CalldataIterator = CalldataIterator;

var ReverseCalldataIterator = /*#__PURE__*/function (_BaseIterator2) {
  _inherits(ReverseCalldataIterator, _BaseIterator2);

  var _super2 = _createSuper(ReverseCalldataIterator);

  function ReverseCalldataIterator(root) {
    _classCallCheck(this, ReverseCalldataIterator);

    return _super2.call(this, root);
  }

  _createClass(ReverseCalldataIterator, [{
    key: "nextBlock",
    value: function nextBlock() {
      return this._queue.popBack();
    }
  }]);

  return ReverseCalldataIterator;
}(BaseIterator);

exports.ReverseCalldataIterator = ReverseCalldataIterator;